import { TBooleanInNumber, TLocale, TTranslate } from './main';
import { POS_SYSTEM_ID } from 'src/constants/integrations';
import { RELEASES } from 'src/constants/main';

export interface ISettings {
  release: RELEASES | string;
  socket: string;
  is_emenu: boolean;
  is_cashback: boolean;
  is_kiosk_app: boolean;
  on_kiosk: boolean;
  is_curbside: boolean;
  is_points: boolean; // deprecated
  is_online_payment: boolean;
  is_upsales: boolean;
  is_waitlist: boolean;
  is_restaurant_working: boolean;
  is_foodics: boolean;
  is_taker360: boolean;
  is_advanced_promocode: boolean;
  is_combo_offer: boolean;
  is_combo_meal: boolean;
  is_mobile_app: boolean;
  is_webhook: boolean;
  is_wallet_usage_limit: boolean;
  is_franchise: boolean; // (is_franchise, franchise_enabled) duplicates according to information on 15.03.2023
  franchise_enabled: boolean; // (is_franchise, franchise_enabled) duplicates according to information on 15.03.2023
  is_franchise_unintegrated_branches: boolean;
  is_deliverect_client: boolean;
  is_branch_profiles_locked: boolean;
  is_cc_zone_orders: boolean;
  delivery_type: string;
  vat_tax: number;
  menu_update: number;
  img_pin: string;
  img_logo: string;
  default_language: TLocale;
  default_image: string | undefined;
  preorder_interval: number;
  takergo_enabled: TBooleanInNumber;
  takergo_assist_token: string;
  allow_order_for_else: boolean;
  is_wallet: boolean;
  client_id: number;
  theme: {
    colors: {
      main_color: string;
      map_controls_color: string;
      tab_bar_text_color: string;
      contrast_text_color: string;
      second_color: string;
      tab_bar_selection_color: string;
      price_color: string;
    };
    web: any;
  };
  time_picker_position: string;
  default_country_code: number;
  cashback: { id: number; name: TTranslate; description: TTranslate; maximum: number; percent: number };
  currency: string;
  currency_code: string;
  currency_position: string;
  translations_url: string;
  menuLayout: string;
  order_notes: boolean;
  item_notes: boolean;
  delivery_vat: number;
  include_vat: number;
  include_delivery_vat: number;
  vat: number;
  vat_included: TBooleanInNumber;
  vat_registration_number: string;
  delivery_time_type: string;
  delivery_gap: number;
  pickup_time_type: string;
  pickup_gap: number;
  mobile: string;
  facebook: string;
  taxable_delivery_fee: number;
  instagram: string;
  twitter: string;
  whatsapp: string;
  app_ios: string;
  app_android: string;
  google_maps_pk: string;
  is_restaurant_name_in_admin_dashboard_title: boolean;
  restaurant_name_en: string;
  restaurant_name_ar: string;
  wallet_currency_ar: string;
  wallet_currency: string;
  dsp_coverage: string;
  is_pos?: boolean;
  pos_system_id?: POS_SYSTEM_ID;
  pos_settings?: {
    branch?: {
      name: boolean;
      hours: boolean;
      sections_and_tables: boolean;
    };
    category?: {
      name: boolean;
    };
    product?: {
      branch_prices: boolean;
      branch_statuses: boolean;
      category: boolean;
      default_options: boolean;
      description: boolean;
      image: boolean;
      name: boolean;
      price: boolean;
      status: boolean;
      stock: boolean;
    };
    modifier?: {
      name: boolean;
      options: boolean;
      unique_options: boolean;
    };
    option?: {
      branch_prices: boolean;
      branch_statuses: boolean;
      name: boolean;
      price: boolean;
      status: boolean;
      stock: boolean;
    };
  };

  donation: {
    branch_id: number;
    enabled: boolean;
  };
  on_takergo_assist?: boolean;
  cookies_enabled?: TBooleanInNumber;
  is_promo_banners: boolean;
  wallet_usage_limit: number;

  simplified_working_hours: TBooleanInNumber;

  is_wallet_combo_payment?: TBooleanInNumber;
}

export type TDeviceType = 'desktop' | 'tablet' | 'mobile';

export const Addons = {
  PromoCode: 'promoCode',
  Deals: 'deals',
  Meals: 'meals',
  Cashback: 'cashback',
  Wallet: 'wallet',
  MobileApp: 'mobileApp',
  Webhook: 'webhook',
  Kiosk: 'kiosk',
  Curbside: 'curbside',
  Franchise: 'franchise',
  PromoBanners: 'promoBanners',
  Emenu: 'emenu',
} as const;
export type TAddons = TValueOf<typeof Addons>;
